import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonFr from './content/common.fr.json';
import commonEn from './content/common.en.json';
import commonHe from './content/common.he.json';
import homeFr from './content/home.fr.json';
import homeEn from './content/home.en.json';
import homeHe from './content/home.he.json';
import chypreFr from './content/chypre.fr.json';
import chypreEn from './content/chypre.en.json';
import chypreHe from './content/chypre.he.json';
import legalFr from './content/legal.fr.json';
import legalEn from './content/legal.en.json';
import legalHe from './content/legal.he.json';
import yoniverseFr from './content/yoniverse.fr.json';
import yoniverseEn from './content/yoniverse.en.json';
import yoniverseHe from './content/yoniverse.he.json';
import accountDeletionFr from './content/account-deletion.fr.json';
import accountDeletionEn from './content/account-deletion.en.json';
import accountDeletionHe from './content/account-deletion.he.json';

const resources = {
  fr: { common: commonFr, home: homeFr, chypre: chypreFr, yoniverse: yoniverseFr, accountDeletion: accountDeletionFr, translation: legalFr },
  en: { common: commonEn, home: homeEn, chypre: chypreEn, yoniverse: yoniverseEn, accountDeletion: accountDeletionEn, translation: legalEn },
  he: { common: commonHe, home: homeHe, chypre: chypreHe, yoniverse: yoniverseHe, accountDeletion: accountDeletionHe, translation: legalHe },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    ns: ['common', 'home', 'chypre', 'yoniverse', 'accountDeletion', 'translation'],
    defaultNS: 'translation',
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18nextLng',
      lookupLocalStorage: 'i18nextLng',
      excludeCacheFor: ['cimode'],
      cookieMinutes: 365,
      htmlTag: document.documentElement,
      cookieOptions: { path: '/', sameSite: 'strict' },
    },
  });

i18n.on('initialized', () => {
  if (!i18n.language || i18n.language === 'fr') {
    const browserLang = navigator.language || navigator.userLanguage;
    if (browserLang) {
      const mainLang = browserLang.split('-')[0].toLowerCase();
      if (mainLang === 'en' || mainLang === 'he') {
        i18n.changeLanguage(mainLang);
      }
    }
  }
});

// RTL: appliquer dir="rtl" sur <html> quand he est actif
i18n.on('languageChanged', (lng) => {
  document.documentElement.dir = lng === 'he' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
});

export default i18n;
